import FileIcon from 'assets/newAssets/fileIcon';
import { v4 as uuidv4 } from 'uuid';
import { QueryInfo } from '../Brief';

const FileList = ({
  isAuthorized,
  files,
  onFileOpen,
  onFileRemove,
  colorsForIcon,
}: {
  isAuthorized: boolean | undefined;
  files: QueryInfo[];
  onFileOpen: (file: QueryInfo) => void;
  onFileRemove: (queryInfo: QueryInfo) => void;

  colorsForIcon: {
    [key: string]: string;
  };
}) => (
  <ul>
    {files.map((file) => {
      const extension = file.name.split('.').pop()?.toUpperCase();
      const color = colorsForIcon[extension || ''] || 'lightgrey';
      const fileWithId = { ...file, id: uuidv4() };

      return (
        <li key={fileWithId.id}>
          <div
            className="fileAndTitleContainer"
            style={{
              cursor: 'pointer',
              width: '90%',
            }}
          >
            <FileIcon color={color} type={extension}></FileIcon>
            <p style={{ fontSize: '.8vw', cursor: 'pointer', width: '90%' }} onClick={() => onFileOpen(file)}>
              {file.name}
            </p>
          </div>
          <div className="buttonRemove" onClick={() => onFileRemove(file)}>
            X
          </div>
          {/* {
          isAuthorized && (
          )} */}
        </li>
      );
    })}
  </ul>
);

export default FileList;
